import * as React from 'react'
import { FunctionComponent } from 'react'
import { Dismiss } from '../Dialog/Command/CommandDialog'
import { useFormikContext } from 'formik'
import CommandButtons, { CommandButtonsProps } from './CommandButtons'

const FormikCommandButtons: FunctionComponent<{ dismiss: Dismiss; lockedSave?: boolean }> = props => {
    const { submitForm } = useFormikContext()
    const buttonProps: CommandButtonsProps = {
        dismissButtonProps: { text: 'Annuleren' },
        primaryButtonProps: { text: 'Opslaan', onClick: () => submitForm(), disabled: props.lockedSave },
        dismiss: props.dismiss,
    }

    return <CommandButtons {...buttonProps} />
}

export default FormikCommandButtons
